import React from "react";
import { Page, View, Text, Image, StyleSheet } from "@react-pdf/renderer";
import { PDF_PAGE } from "../../constants/pdfSizes";
import defaultBg from "../../assets/thankyou.jpg";
import meetIcon from "../../assets/meetIcon.png";
import callIcon from "../../assets/callIcon.png";
import writeIcon from "../../assets/writeIcon.png";
import logo from "../../assets/efficient-logo.png";
import whatIcon from "../../assets/whatIcon.png";
import gradientOverlay from "../../assets/thanksOverlay.png"; 

const styles = StyleSheet.create({
  page: {
    width: PDF_PAGE.width,
    height: PDF_PAGE.height,
    position: "relative",
    backgroundColor: "#000",
  },
  background: {
    position: "absolute",
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  overlay: {
    position: "absolute",
    top: 0,
    left: 0,
    width: PDF_PAGE.width,
    height: PDF_PAGE.height,
    opacity: 1,
    objectFit: "contain",
  },
  container: {
    paddingHorizontal: 40,
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    justifyContent: "center",
  },
  title: {
    fontFamily: "Montserrat",
    fontSize: 44,
    textAlign: "center",
    color: "#fff",
    fontWeight: "medium",
    marginBottom: 0,
    textTransform: "uppercase",
    display: "block"
   
  },
  subtitle: {
    fontFamily: "Montserrat",
    fontSize: 16,
    textAlign: "center",
    color: "#fff",
    marginBottom: 30,
    lineHeight: 1.5,
  },
  cardsWrapper: {
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
    marginTop: 50,
  },
  card: {
    width: "30%",
    borderWidth: 1,
    borderColor: "#F1B1D3",
    borderRadius: 10,
    backgroundColor: "rgba(255, 255, 255, 0.02)",
    paddingTop: 30,
    paddingHorizontal: 10,
    paddingBottom: 2,
    alignItems: "center",
    position: "relative",
  },
  iconSection: {
    position: "absolute",
    top: -35,
    width: "100%",
    alignItems: "center",
    zIndex: 10,
  },
  iconBackground: {
    width: "80%",
    height: 50,
    backgroundColor: "#fff",
    borderRadius: 8,
    justifyContent: "center",
    alignItems: "center",
    borderColor: "#F1B1D3",
    borderWidth: 2,
    zIndex: 9,
  },
  iconCircle: {
    width: 75,
    height: 75,
    backgroundColor: "#fff",
    borderRadius: 100,
    justifyContent: "center",
    alignItems: "center",
    marginTop: -35,
  },
  iconImage: {
    width: 40,
    height: 40,
    objectFit: "contain",
  },
  button: {
    marginTop: 10,
    marginBottom: 12,
    borderRadius: 4,
    paddingVertical: 4,
    paddingHorizontal: 10,
    fontSize: 12,
    fontFamily: "Montserrat",
    fontWeight: "medium",
    textAlign: "center",
    color: "#fff",
    backgroundColor: "#D62828",
  },
  buttonBlue: {
    backgroundColor: "#003566",
  },
  heading: {
    fontSize: 18,
    color: "#fff",
    fontFamily: "Montserrat",
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: 8,
    textTransform: "uppercase",
  },
  text: {
    fontSize: 14,
    color: "#fff",
    fontFamily: "Montserrat",
    textAlign: "center",
    lineHeight: 1.5,
    marginTop: 10,
  },
  email: {
    fontSize: 16,
    fontFamily: "Montserrat",
    color: "#fff",
    textAlign: "center",
  },
  emailHead: {
    fontSize: 22,
    fontFamily: "Montserrat",
    color: "#fff",
    textAlign: "center",
    fontWeight: "semibold",
    marginTop: 10,
  },
  logoBox: {
    backgroundColor: "#fff",
    padding: 10,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomLeftRadius: 40,
    borderBottomRightRadius: 40,
    alignSelf: "center", 
    marginBottom: 20,
    width: 300,
    textAlign: "center",
  },
  logo: {
    width: 186,
    height: 47,
    margin: "auto",
  },
  headingWrapper: {
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  bigtext: {
    fontSize: 20,
    color: "#fff",
    fontFamily: "Montserrat",
    textAlign: "center",
    lineHeight: 1.5,
    fontWeight: "medium",
  },
  whatIcon: {
    width: 45,
    height: 45,
    marginTop: 10,
    marginBottom: 15,
  },
});

const ThankYouSlide = ({
  bg,
  title = "Thank you",
  subtitle = "Let’s Make Your Next Trip Unforgettable.",
  thankyouGroup = [],
}) => {
  const defaultBgImage = bg || defaultBg;
  const getIcon = (type) => {
    switch (type?.toLowerCase()) {
      case "meet us":
        return meetIcon;
      case "call us":
        return callIcon;
      case "write us":
        return writeIcon;
      default:
        return null;
    }
  };

  const getButtonStyle = (type) => {
    switch (type?.toLowerCase()) {
      case "call us":
        return [styles.button, styles.buttonBlue];
      case "meet us":
      case "write us":
      default:
        return styles.button;
    }
  };

  return (
    <Page size={PDF_PAGE} style={styles.page}>
     <Image src={defaultBgImage} style={styles.background} />
      <Image src={gradientOverlay} style={styles.overlay} />

      <View style={styles.container}>
         
        <View>
          {logo && (
            <View style={styles.logoBox}>
              <Image src={logo} style={styles.logo} />
            </View>
          )}
        </View>

        <View style={styles.headingWrapper}>
          <Text style={styles.title}>{title}</Text>
          <Text style={styles.subtitle}>{subtitle}</Text>
        </View>

        <View style={styles.cardsWrapper}>
          {thankyouGroup.map((item, idx) => (
            <View key={idx} style={styles.card}>
              {/* Icon */}
              <View style={styles.iconSection}>
                <View style={styles.iconBackground}>
                  <View style={styles.iconCircle}>
                    <Image src={getIcon(item.type)} style={styles.iconImage} />
                  </View>
                </View>
              </View>
              {/* Button */}
              <Text style={getButtonStyle(item.type)}>
                {item.type?.toUpperCase() || ""}
              </Text>

              {/* Heading */}
              <Text style={styles.heading}>{item.heading}</Text>

              {/* Content */}
              {item.address && (
                <Text style={[styles.text]}>{item.address}</Text>
              )}

              {item.phoneNumberOne && (
                <Text style={[styles.bigtext]}>{item.phoneNumberOne}</Text>
              )}
              {item.phoneNumberOne && (
                <Image style={styles.whatIcon} src={whatIcon} />
              )}

              {item.phoneNumberTwo && (
                <Text style={styles.bigtext}>{item.phoneNumberTwo}</Text>
              )}

              {item.email && (
                <>
                  <Text style={styles.emailHead}>info@</Text>
                  <Text style={styles.email}>{item.email.split("@")[1]}</Text>
                </>
              )}
            </View>
          ))}
        </View>
      </View>
    </Page>
  );
};

export default ThankYouSlide;
